import { render, staticRenderFns } from "./MaintenanceItemFormDialog.vue?vue&type=template&id=87f0d370"
import script from "./MaintenanceItemFormDialog.vue?vue&type=script&lang=ts"
export * from "./MaintenanceItemFormDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports